import * as React from 'react'
import {Box} from "@mui/material";
import {formatPercentage} from "@ui-seeker/utils";

import { ArrowBackground, NotAllowedBlock } from '@components';


export default function percentageColumn(key, label, decimals=0, invertColors=false) {
	return {
		name: key, label: label,
		options: {
			setCellHeaderProps: () => ({ sx: {
				whiteSpace: 'pre-wrap',
			}}),
			customBodyRowRenderLite: value => {
				const displayValue = -value
				const positiveColor = invertColors ? 'error.light' : 'success.light'
				const negativeColor = invertColors ? 'success.light' : 'error.light'
				const backgroundColor = displayValue > 0
					? positiveColor
					: displayValue < 0
						? negativeColor
						: 'grey.300'
				return <Box sx={{ textAlign: 'center' }}>
					<ArrowBackground
						value={displayValue}
						backgroundColor={backgroundColor}
					>
						{formatPercentage(displayValue, { decimals: 2 })}
					</ArrowBackground>
				</Box>
			}
		}
	}
}